export default __webpack_public_path__ + "220fed7444ec54dd601b501cb7604769.png";